import { ready } from "//us.roborock.com/cdn/shop/t/86/assets/GA4-track-directive-core.js?v=137848537919169991971779158146&vTrack=202605191002";
import { trackReport } from "//us.roborock.com/cdn/shop/t/86/assets/GA4-track-directive-report.js?v=104115401213510859531778857371&vTrack=202605191002";
import {
  bindTrackClick,
  setupGlobalClickTracking,
} from "//us.roborock.com/cdn/shop/t/86/assets/GA4-track-directive-vTrackClick.js?v=80408537346979321391779158541&vTrack=202605191002";
import { bindTrackHover } from "//us.roborock.com/cdn/shop/t/86/assets/GA4-track-directive-vTrackHover.js?v=118070476163344348661779158541&vTrack=202605191002";
import { bindTrackVisible } from "//us.roborock.com/cdn/shop/t/86/assets/GA4-track-directive-vTrackVisible.js?v=7698934736169282871779158541&vTrack=202605191002";
import { bindTrackVisibleTime } from "//us.roborock.com/cdn/shop/t/86/assets/GA4-track-directive-vTrackVisibleTime.js?v=105553995790886873621779158541&vTrack=202605191002";

/**
 * Shopify GA4埋点指令运行时
 *
 * 目的：在非 Vue 的 Shopify 静态模板里，模拟自建站的 `v-track-*` 指令写法。
 * 页面 HTML 只负责声明：
 * - `v-track-context='{...}'`：给子元素注入公共参数
 * - `v-track-click:event_name='{...}'`：点击上报
 * - `v-track-click:event_name.bubble='{...}'`：冒泡阶段上报
 * - `v-track-click:event_name.delegate='{...}'`：委托点击上报
 * - `v-track-hover:event_name='{...}'`：悬停/聚焦上报
 * - `v-track-hover:event_name.once='{...}'`：悬停/聚焦只上报一次
 * - `v-track-visible:event_name='{...}'`：元素曝光上报
 * - `v-track-visible-time='{...}'`：曝光和停留时长上报
 * - `v-track-visible-time.once='{...}'`：曝光和停留时长只上报一次
 * - `v-track-global-params='{...}'`：挂载到 window.__trackData 的全局埋点参数
 *
 * 注意：模板里的参数必须是合法 JSON 字符串，不使用 eval，避免脚本注入风险。
 */

// 扫描全页面元素并按声明的 `v-track-*` 属性绑定对应埋点行为。
function init() {
  setupGlobalClickTracking();

  const elements = Array.prototype.slice.call(document.getElementsByTagName('*'));

  elements.forEach(function (el) {
    bindTrackClick(el);
    bindTrackHover(el);
    bindTrackVisible(el);
    bindTrackVisibleTime(el);
  });
}

// 保留手动上报入口，方便少数无法用指令覆盖的异步场景复用同一 dataLayer 结构。
window.pushGa4TrackEvent = function (eventName, eventParameters) {
  trackReport({
    event_name: eventName,
    event_parameters: eventParameters || {},
  });
};

// 暴露手动重扫入口，供页面异步插入带指令 DOM 后主动初始化。
window.initGa4TrackDirectives = function () {
  init();
};

ready(init);